import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import moment from 'moment-timezone';

function state() {
    return {
        isLoading: false,
        isPosting: false,
        media: null,
        show_form: false,
        error_message: null,
        websites: [],
        show_website_question: false,
        social_networks: [],
        shareable_networks: [],
        posts: [],
        twitter_url_length: null,
        is_video_link: null,

        formData: {
            id: null,
            saved_media_id: null,
            post_now: false,
            media_id: null,
            video_url: null,
            max_date: null,
            editable: null,
            social_networks: [],
            post_date: null,
            post_time: '13:00:00',
            remove_date: null,
            post_message: '',
            website: '',
            post_image_url: null,
        },

        formEditableParam: null,
        params: {
            page: 1,
            page_size: 20,
            search: null,
            sort: 'post_date',
            social_networks: [],
            type: null
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
